(function () {
  'use strict';

  var STICKY_SELECTOR = '[data-mg-sticky-atc]';

  function initStickyAddToCart(bar) {
    if (!bar || bar.dataset.mgStickyInitialized === 'true') return;

    var section = bar.closest('[data-section-type="product"]') || document;
    var mainForm = section.querySelector('#add-to-cart-form') || document.querySelector('#add-to-cart-form');
    if (!mainForm) return;

    var mainButton = mainForm.querySelector('[data-btn-addToCart], #product-add-to-cart');
    var purchaseControls = mainForm.querySelector('.groups-btn') || mainButton;
    var stickyButton = bar.querySelector('[data-mg-sticky-submit]');
    var stickyVariant = bar.querySelector('[data-mg-sticky-variant]');
    var stickyPrice = bar.querySelector('[data-mg-sticky-price]');
    var stickyComparePrice = bar.querySelector('[data-mg-sticky-compare-price]');
    var stickyImage = bar.querySelector('[data-mg-sticky-image]');
    var syncTimer;

    if (!mainButton || !purchaseControls || !stickyButton) return;

    bar.dataset.mgStickyInitialized = 'true';

    function getVariantSelect() {
      return mainForm.querySelector('#product-selectors, select[name="id"]');
    }

    function copyPrice() {
      var currentPrice = section.querySelector('.product-shop #productPrice .money, .product-shop #productPrice');
      var comparePrice = section.querySelector('.product-shop .prices > .compare-price .money, .product-shop .prices > .compare-price');

      if (currentPrice && stickyPrice) {
        stickyPrice.textContent = currentPrice.textContent.trim();
      }

      if (stickyComparePrice) {
        var compareText = comparePrice ? comparePrice.textContent.trim() : '';
        stickyComparePrice.textContent = compareText;
        stickyComparePrice.hidden = !compareText;
      }
    }

    function isMainButtonPending() {
      var buttonWrapper = mainButton.closest('.atc-btn');
      return !!(buttonWrapper && buttonWrapper.classList.contains('is-adding'));
    }

    function syncButtonState() {
      var pending = isMainButtonPending();
      stickyButton.disabled = mainButton.disabled || pending;
      stickyButton.setAttribute('aria-busy', pending ? 'true' : 'false');
    }

    function syncFromMainForm() {
      var variantSelect = getVariantSelect();
      var selectedOption = variantSelect && variantSelect.options
        ? variantSelect.options[variantSelect.selectedIndex]
        : null;
      var variantTitle = selectedOption ? selectedOption.textContent.trim() : '';
      var variantImage = selectedOption ? selectedOption.getAttribute('data-imge') : '';
      var buttonLabel = mainButton.value || mainButton.textContent.trim();

      if (stickyVariant && variantSelect) {
        var shouldHideVariant = !variantTitle || variantTitle === 'Default Title';
        stickyVariant.hidden = shouldHideVariant;
        stickyVariant.textContent = shouldHideVariant ? '' : variantTitle.split(' / ').join(' | ');
      }

      if (variantImage && stickyImage) {
        stickyImage.src = variantImage;
      }

      stickyButton.textContent = buttonLabel;
      syncButtonState();
      copyPrice();
    }

    function scheduleSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncFromMainForm, 40);
    }

    function updatePreviewOffset() {
      // Shopify clips a full-height iframe inside this toolbar-sized wrapper.
      var previewBar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
      var offset = 0;

      if (previewBar) {
        var previewRect = previewBar.getBoundingClientRect();
        if (previewRect.top > 0 && previewRect.top < window.innerHeight && previewRect.bottom >= window.innerHeight - 2) {
          offset = Math.max(0, Math.round(window.innerHeight - previewRect.top));
        }
      }

      bar.style.setProperty('--mg-sticky-atc-bottom', offset + 'px');
    }

    function updateVisibility() {
      var hasPassedPurchaseControls = purchaseControls.getBoundingClientRect().bottom <= 0;
      bar.classList.toggle('is-visible', hasPassedPurchaseControls);
      bar.setAttribute('aria-hidden', hasPassedPurchaseControls ? 'false' : 'true');
      bar.inert = !hasPassedPurchaseControls;
      updatePreviewOffset();
    }

    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled || isMainButtonPending()) {
        syncButtonState();
        return;
      }
      mainButton.click();
      syncButtonState();
    });

    mainForm.addEventListener('change', scheduleSync);
    mainForm.addEventListener('input', scheduleSync);
    mainForm.addEventListener('click', scheduleSync);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    var formObserver = new MutationObserver(scheduleSync);
    formObserver.observe(mainForm, {
      attributes: true,
      attributeFilter: ['disabled', 'src', 'value', 'class'],
      childList: true,
      characterData: true,
      subtree: true
    });

    window.setTimeout(scheduleSync, 120);
    window.setTimeout(updateVisibility, 120);
    syncFromMainForm();
    updateVisibility();
  }

  function initAllStickyAddToCart(root) {
    var scope = root || document;
    scope.querySelectorAll(STICKY_SELECTOR).forEach(initStickyAddToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllStickyAddToCart(document);
    });
  } else {
    initAllStickyAddToCart(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllStickyAddToCart(event.target);
  });
})();
